// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const planGQLFields = (fields) => `
  createdAt
  endDate
  extendable
  memberCapacity
  name
  renewDate
  renewalType
  seatCapacity
  startDate
  trial
`;
//# sourceMappingURL=plan.fields.js.map